<template>
  <div class="usage-recording container">
    <div class="d-flex justify-content-between align-items-center my-8">
      <div>
        <h4 class="text-dark fw-bold mb-1">Ghi nhận Sử dụng Dịch vụ</h4>
        <p class="text-muted m-0">Theo dõi việc sử dụng thuốc, Service Package và dịch vụ</p>
      </div>
      <div class="d-flex gap-3">
        <button v-if="isViewPermission" class="btn btn-outline-success font-weight-medium mr-2" @click="exportReport">
          <i class="fas fa-download mr-2"></i>Xuất báo cáo
        </button>
        <button v-if="isInsertPermission" class="btn btn-success font-weight-medium" @click="createUsage">
          <i class="fas fa-plus mr-2"></i>Ghi nhận mới
        </button>
      </div>
    </div>

    <div class="filter-bar bg-white rounded border mb-6">
      <div class="d-flex flex-wrap align-items-center">
        <div class="col-md-2 p-2 filter-col-input">
          <div class="position-relative">
            <i class="fas fa-search search-icon"></i>
            <input
              v-model="filters.search"
              type="text"
              class="form-control search-input"
              placeholder="Tìm kiếm theo số điện thoại khách hàng"
              @input="handleSearch"
            />
          </div>
        </div>

        <div class="col-md-2 p-2">
          <basic-select
            label=""
            placeholder="Tất cả loại"
            name="itemType"
            :options="itemTypeOptions"
            track-by="value"
            value-label="text"
            :value.sync="itemTypeValue"
            @input="filters.itemType = $event != null ? $event : ''; handleSearch()"
          />
        </div>

        <div class="col-md-2 p-2">
          <basic-date-picker
            :value.sync="filters.dateFrom"
            label=""
            placeholder="Từ ngày"
            name="dateFrom"
            format="DD/MM/YYYY"
            @input="handleSearch"
          />
        </div>

        <div class="col-md-2 p-2">
          <basic-date-picker
            :value.sync="filters.dateTo"
            label=""
            placeholder="Đến ngày"
            name="dateTo"
            format="DD/MM/YYYY"
            @input="handleSearch"
          />
        </div>

        <div class="col-md-2 p-2 d-flex align-items-center">
          <button class="btn btn-secondary btn-reset-filter w-100" @click="resetFilters">
          Reset bộ lọc
          </button>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-4">
        <div class="summary-card">
          <div class="summary-card__label">Thuốc đã dùng</div>
          <div class="summary-card__value text-success">{{ stats.medicine }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="summary-card">
          <div class="summary-card__label">Gói dịch vụ chuyên sâu</div>
          <div class="summary-card__value text-success">{{ stats.servicePackage }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="summary-card">
          <div class="summary-card__label">Dịch vụ đã dùng</div>
          <div class="summary-card__value text-success">{{ stats.service }}</div>
        </div>
      </div>
    </div>

    <div class="mb-2">
      <span class="text-muted">Hiển thị {{ items.length }} bản ghi</span>
    </div>

    <b-overlay :show="loading">
      <div class="row">
        <div v-for="item in items" :key="item.id" class="col-12 p-2">
          <div class="record-card">
            <div class="d-flex align-items-start justify-content-between flex-wrap">
              <div class="d-flex align-items-start flex-grow-1 pr-4">
                <div class="record-icon mr-4" :class="iconBgClass(item)">
                  <i :class="iconClass(item)"></i>
                </div>

                <div class="flex-grow-1">
                  <div class="d-flex align-items-center flex-wrap mb-1">
                    <span class="type-pill mr-2" :class="typePillClass(item)">
                      {{ typeLabel(item) }}
                    </span>
                    <div class="record-title">{{ item.title }}</div>
                  </div>

                  <div class="record-meta text-muted">
                    <div class="mb-1">
                      Khách hàng:
                      <span class="text-dark font-weight-medium">{{ item.customerName }}</span>
                    </div>
                    <div class="mb-1">Số lượng: <span class="text-dark font-weight-medium">{{ item.quantity }}</span></div>
                    <div v-if="item.note" class="text-muted">{{ item.note }}</div>
                  </div>
                </div>
              </div>

              <div class="text-right d-flex align-items-center gap-3 mt-2 mt-md-0">
                <div class="record-time text-secondary mr-4">
                  <div class="font-weight-medium text-dark">{{ formatDate(item.usedAt) }}</div>
                  <div class="small text-secondary">{{ formatTime(item.usedAt) }}</div>
                </div>
                <button class="btn btn-secondary btn-sm px-4" @click="viewCustomer(item)">
                  <i class="far fa-eye mr-2"></i>Xem KH
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="items.length === 0 && !loading" class="col-12 text-center py-12">
          <i class="fas fa-clipboard-list fa-3x text-muted mb-4 d-block"></i>
          <p class="text-muted">Chưa có bản ghi sử dụng nào.</p>
        </div>
      </div>

      <div v-if="paging.total > 0" class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center">
          <b-form-select
            v-model="paging.pageSize"
            :options="pageSizeOptions"
            size="sm"
            style="width: 80px;"
            class="page-size-select"
          />
        </div>
        <b-pagination
          v-model="paging.page"
          :total-rows="paging.total"
          :per-page="paging.pageSize"
          size="md"
          class="mb-0 pagination-custom"
          first-number
          last-number
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
const ITEM_TYPE_MAP = {
  0: 'medicine',
  1: 'service_package',
  2: 'service',
};

const ITEM_TYPE_LABEL = {
  0: 'Thuốc',
  1: 'Gói DV chuyên sâu',
  2: 'Dịch vụ',
};

export default {
  name: 'UsageRecording',
  data() {
    return {
      loading: false,
      debounceTimer: null,
      items: [],
      filters: {
        search: '',
        itemType: '',
        dateFrom: '',
        dateTo: '',
        accountHisId: '',
      },
      itemTypeOptions: [
        { value: '0', text: 'Thuốc' },
        { value: '1', text: 'Gói dịch vụ chuyên sâu' },
        { value: '2', text: 'Dịch vụ' },
      ],
      stats: {
        medicine: 0,
        servicePackage: 0,
        service: 0,
      },
      paging: {
        page: 1,
        pageSize: 12,
        total: 0,
      },
      pageSizeOptions: [
        { value: 6,  text: '6' },
        { value: 12, text: '12' },
        { value: 24, text: '24' },
      ],
    };
  },
  computed: {
    itemTypeValue: {
      get() {
        return this.itemTypeOptions.find((o) => o.value === this.filters.itemType) || null;
      },
      set(obj) {
        this.filters.itemType = obj?.value ?? '';
      },
    },
    searchParams() {
      const params = new URLSearchParams();
      params.append('page', this.paging.page);
      params.append('size', this.paging.pageSize);
      if (this.filters.search) params.append('phoneNumber', this.filters.search);
      if (this.filters.itemType !== '') params.append('itemType', this.filters.itemType);
      if (this.filters.accountHisId) params.append('AccountHisId', this.filters.accountHisId);
      if (this.filters.dateFrom) {
        const d = this.parsePickerDate(this.filters.dateFrom);
        if (d) params.append('startDate', Math.floor(d.getTime() / 1000));
      }
      if (this.filters.dateTo) {
        const d = this.parsePickerDate(this.filters.dateTo, { endOfDay: true });
        if (d) params.append('endDate', Math.floor(d.getTime() / 1000));
      }
      return params;
    },
    // Filter params dùng cho API count (không có page/size)
    countParams() {
      const params = new URLSearchParams();
      if (this.filters.search) params.append('phoneNumber', this.filters.search);
      if (this.filters.itemType !== '') params.append('itemType', this.filters.itemType);
      if (this.filters.accountHisId) params.append('AccountHisId', this.filters.accountHisId);
      if (this.filters.dateFrom) {
        const d = this.parsePickerDate(this.filters.dateFrom);
        if (d) params.append('startDate', Math.floor(d.getTime() / 1000));
      }
      if (this.filters.dateTo) {
        const d = this.parsePickerDate(this.filters.dateTo, { endOfDay: true });
        if (d) params.append('endDate', Math.floor(d.getTime() / 1000));
      }
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadItems();
    },
    'paging.pageSize'() {
      this.paging.page = 1;
      this.loadItems();
    },
  },
  mounted() {
    if (this.$route?.query?.accountHisId) {
      this.filters.accountHisId = this.$route.query.accountHisId;
    }
    this.loadItems();
    this.loadStats();
  },
  activated() {
    if (this.$route?.query?.accountHisId) {
      this.filters.accountHisId = this.$route.query.accountHisId;
    }
    this.loadItems();
    this.loadStats();
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    handleSearch() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.paging.page = 1;
        this.loadItems();
        this.loadStats();
      }, 2000);
    },

    resetFilters() {
      this.filters = {
        search: '',
        itemType: '',
        dateFrom: '',
        dateTo: '',
        accountHisId: '',
      };
      this.paging.page = 1;
      this.loadItems();
      this.loadStats();
    },

    async loadItems() {
      try {
        this.loading = true;
        const res = await this.$api.get('ServiceUsages', {
          params: this.searchParams,
        });
        const raw = res?.data ?? res;
        const data = raw?.data ?? raw;
        const items = data?.items ?? [];

        this.items = items.map((item) => {
          const acct = item.accountHis || {};
          const type = ITEM_TYPE_MAP[item.itemType] || 'service';

          return {
            id: item.id,
            type,
            title: ITEM_TYPE_LABEL[item.itemType] || 'Không rõ',
            customerName:  acct.fullName || acct.firstName || 'Không rõ',
            quantity: item.quantity || 0,
            note: item.note || '',
            usedAt: item.createDatetime,
            status: item.status,
            userBundleOrderId: item.userBundleOrderId || null,
          };
        });

        this.paging.total = data?.total ?? items.length;
      } catch (error) {
        console.error('Lỗi tải danh sách sử dụng:', error);
        this.$toastr?.e?.({
          title: 'Lỗi',
          msg: 'Không thể tải danh sách sử dụng. Vui lòng thử lại.',
        });
        this.items = [];
        this.paging.total = 0;
      } finally {
        this.loading = false;
      }
    },


    async loadStats() {
      try {
        const res = await this.$api.get('ServiceUsages/service-usages-count', {
          params: this.countParams,
        });
        const raw = res?.data ?? res;
        const d = raw?.data ?? raw;
        this.stats = {
          medicine: d?.item1 ?? 0,
          servicePackage: d?.item2 ?? 0,
          service: d?.item3 ?? 0,
        };
      } catch (error) {
        console.error('Lỗi tải thống kê sử dụng:', error);
      }
    },

    typeLabel(item) {
      if (item.type === 'medicine') return 'Thuốc';
      if (item.type === 'service_package') return 'Gói DV';
      return 'Dịch vụ';
    },
    typePillClass(item) {
      if (item.type === 'medicine') return 'pill-medicine';
      if (item.type === 'service_package') return 'pill-package';
      return 'pill-service';
    },
    iconClass(item) {
      if (item.type === 'medicine') return 'fas fa-pills';
      if (item.type === 'service_package') return 'fas fa-layer-group';
      return 'fas fa-stethoscope';
    },
    iconBgClass(item) {
      if (item.type === 'medicine') return 'icon-medicine';
      if (item.type === 'service_package') return 'icon-package';
      return 'icon-service';
    },

    exportReport() {
      this.$toastr?.s?.({ title: 'Thông báo', msg: 'Chức năng xuất báo cáo sẽ được cập nhật.' });
    },
    createUsage() {
      this.$router.push({ name: 'usage_recording_create' });
    },
    viewCustomer(item) {
      if (!item.userBundleOrderId) {
        this.$toastr?.e?.({ title: 'Lỗi', msg: 'Không tìm thấy thông tin gói đăng ký.' });
        return;
      }
      this.$router.push({
        name: 'package_registration_detail',
        params: { id: item.userBundleOrderId },
      });
    },

    formatDate(val) {
      const d = this.parseAnyDate(val);
      if (!d) return '?';
      return this.$moment(d).format('D/M/YYYY');
    },
    formatTime(val) {
      const d = this.parseAnyDate(val);
      if (!d) return '';
      return this.$moment(d).format('HH:mm');
    },
    parseAnyDate(val) {
      if (!val) return null;
      if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : val;
      if (typeof val === 'number') {
        const ms = val < 1e10 ? val * 1000 : val;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      if (typeof val === 'string') {
        const m = this.$moment(val, ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
        if (m.isValid()) return m.toDate();
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      return null;
    },
    parsePickerDate(val, { endOfDay = false } = {}) {
      if (!val) return null;
      const d = this.parseAnyDate(val);
      if (!d) return null;
      const out = new Date(d);
      if (endOfDay) out.setHours(23, 59, 59, 999);
      else out.setHours(0, 0, 0, 0);
      return out;
    },
  },
};
</script>

<style scoped lang="scss">
.usage-recording {
  padding: 0;
}

.filter-bar {
  padding: 16px 20px;
  .row {
    row-gap: 10px;
  }

  ::v-deep .form-group {
    margin-bottom: 0;
    label {
      display: none;
    }
  }

  .filter-col-input {
    display: flex;
    align-items: center;
  }
}

.search-input {
  padding-left: 38px;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
  height: 42px;
}
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a1a5b7;
  z-index: 5;
  font-size: 0.85rem;
}
.filter-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a1a5b7;
  z-index: 5;
  font-size: 0.82rem;
}
.filter-select {
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
  font-size: 0.9rem;
}
.pl-icon {
  padding-left: 34px;
}

.summary-card {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  padding: 18px 22px;

  &__label {
    font-size: 0.85rem;
    color: #7e8299;
    margin-bottom: 6px;
  }
  &__value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
  }
}

.text-purple {
  color: #6f42c1;
}

.record-card {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 14px;
  padding: 18px 20px;
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(76, 87, 125, 0.12);
  }
}

.record-icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  i {
    font-size: 1rem;
  }
}
.icon-medicine {
  background: #eef6ff;
  color: #3b82f6;
}
.icon-package {
  background: #e8fff3;
  color: #17c653;
}
.icon-service {
  background: #f4f1ff;
  color: #6f42c1;
}

.type-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.78rem;
  font-weight: 600;
}
.pill-medicine {
  background: #eef6ff;
  color: #3b82f6;
}
.pill-package {
  background: #e8fff3;
  color: #17c653;
}
.pill-service {
  background: #f4f1ff;
  color: #6f42c1;
}

.record-title {
  font-weight: 700;
  color: #181c32;
  font-size: 1.02rem;
}
.record-meta {
  font-size: 0.88rem;
}
.record-time {
  min-width: 84px;
}

.page-size-select {
  border-color: #dee2e6;
  font-size: 0.875rem;
}
::v-deep .pagination-custom {
  .page-item {
    &.active .page-link {
      background-color: #01645A;
      border-color: #01645A;
      color: #fff;
    }
    .page-link {
      color: #21a567;
      &:hover {
        background-color: #e8f8f0;
        border-color: #21a567;
        color: #21a567;
      }
    }
  }
}

</style>